import { createStore, applyMiddleware } from 'redux';
import { reducers } from './druid/./druid/rootReducer';
import { initialAppState } from '/druid/reduxState';
import { composeWithDevTools } from 'redux-devtools-extension';

export const createAppStore  = () =>  createStore(reducers, initialAppState, composeWithDevTools());
